var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.teams.length > 0)?_c('TotemSelect',{ref:"shareWatchListTeamFilter",staticClass:"filter-select-team",attrs:{"options":_vm.teams,"placeholder":_vm.$t('WatchListModal.team_filter_label'),"width":_vm.getTeamFilterWidth,"value":_vm.teamFilter,"size":"small"},on:{"input":_vm.selectTeam}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }